module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headeracknow01",
      "epub:type": "acknowledgments",
      "id": "acknow",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', {
    attrs: {
      "id": "headeracknow01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page vi. ",
      "epub:type": "pagebreak",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page vii. ",
      "epub:type": "pagebreak",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsutvmsciencefiction0007#racknow"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("wenty years ago I had the opportunity to lead off Wayne State University’s new TV Milestones series with my volume "), _c('i', [_vm._v("Disney TV")]), _vm._v(". I want to thank the press, and especially series editor Barry Grant and senior acquisitions editor Marie Sweetman, for being receptive to and indeed encouraging the idea of my authoring a second TV Milestones book. Let me also express my appreciation for copy editor Jude Grant’s deft touch, which has made the book a more pleasing read. Providing valuable assistance to my research were the staff members at the Wisconsin Center for Film and Theater Research, particularly Mary Huelsbeck and Lisa Marine. Finally, I need to thank my wife, Leigh Ehlers Telotte, for her support and advice throughout the writing and production process. This book is dedicated to her.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed8e045","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-tvmsciencefiction-0008.vue
// module id = 75
// module chunks = 0